import script from "./ModuleStat.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleStat.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleStat.vue?vue&type=style&index=0&id=3a7d878c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7d878c"]])

export default __exports__